// Config
import { staticConfig } from '../config/static';
import { PkceChallenge } from './pkce';

export function shouldSkipAuth() {
    return staticConfig.auth.anonymousRoutes.includes(window.location.pathname);
}

export async function loginRedirect(useTestIdp?: boolean) {
    const pkce = new PkceChallenge();
    const codeVerifier = pkce.generateRandomString();
    const state = pkce.generateRandomString();
    const nonce = pkce.generateRandomString();
    sessionStorage.setItem('codeVerifier', codeVerifier);
    sessionStorage.setItem('codeNonce', nonce);
    sessionStorage.setItem('codeState', state);
    const query = {
        response_type: 'code',
        client_id: staticConfig.apiClientId,
        redirect_uri: staticConfig.appBaseUrl.slice(0, -1),
        scope: staticConfig.auth.scopes.join(' '),
        state: state,
        nonce: nonce,
        code_challenge: await pkce.generateChallenge(codeVerifier),
        code_challenge_method: 'S256',
        idp: useTestIdp ? 'testidp' : 'nemloginEboksRealm',
        // deviceName: 'SletMigSenere',
        // deviceId: 'a56e822a-3adb-4ef9-8f63-dd4b061056f1',
    };
    const qs = Object.keys(query)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
        .join('&');
    const redirUrl =
        staticConfig.authServerAuthorizeTestIdpEndpoint && useTestIdp
            ? staticConfig.authServerAuthorizeTestIdpEndpoint
            : staticConfig.authServerAuthorizeEndpoint;

    window.location.href = redirUrl + qs;
}

export function clearAuthStorage() {
    window.sessionStorage.clear();
    window.localStorage.removeItem('mailboxId');
    window.localStorage.removeItem('selectedOrganizationName');
    window.localStorage.removeItem('selectedOrganizationId');
    window.localStorage.removeItem('refresh_token');
    window.localStorage.removeItem('userWasCreated');
    window.localStorage.removeItem('loginFlowComplete');
    window.localStorage.removeItem('isAuthenticated');
    window.localStorage.removeItem('classicLogonPlace');
    window.localStorage.getItem('zoomLevel') != null && window.localStorage.removeItem('zoomLevel');
    // window.localStorage.removeItem('idptest');
}

export function isAuthenticated() {
    return !!sessionStorage.getItem('userId');
}
